import {
  OtherAdditionItem,
  OtherAdditionItemType,
} from "@/models/other-addition-items.model";
import apiClient from "./apiClient";

export async function getOtherAdditionItems(args: {
  userId: number;
  month: number;
  year: number;
}): Promise<OtherAdditionItem[]> {
  const { userId, month, year } = args;
  const res = await apiClient.get(
    `/users/${userId}/other-addition-items?month=${month}&year=${year}`
  );
  const data: OtherAdditionItem[] = res.data as OtherAdditionItem[];
  return data;
}

export async function addHocItem(args: {
  amount: number;
  type: OtherAdditionItemType;
  payslipId?: number;
  userId?: number;
  month?: number;
  year?: number;
}): Promise<OtherAdditionItem> {
  const res = await apiClient.post("/other-addition-items", {
    ...args,
  });
  const data: OtherAdditionItem = res.data as OtherAdditionItem;
  return data;
}

export async function deleteOtherAdditionItem(id: number): Promise<boolean> {
  const res = await apiClient.delete(`/other-addition-items/${id}`);
  return res.data as boolean;
}
